export const ServiceTypeName = {
  OIL_CHANGE: 'Oil Change',
  BRAKE_SERVICE: 'Brake Service',
  FULL_SERVICE: 'Full Service',
  INSPECTION: 'Inspection',
  REPAIR: 'Repair',
  MAINTENANCE: 'Maintenance',
  OTHER: 'Other',
};
